import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { HomeService } from '@app/shared/services/home.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-hero-container',
  styleUrls: ['./hero-container.component.scss'],
  templateUrl: './hero-container.component.html'
})
export class HeroContainerComponent implements OnInit {
  @Input() foldText;
  @Input() header;
  @Input() heroIllustration;
  @Input() hideSubheadersOnMobile = false;
  @Input() isSvbPage: boolean;
  @Input() showCTAButton = true;
  @Input() showSecondaryNavButtons = true;
  @Input() subheadings: string[];

  href: string;

  constructor(private homeService: HomeService, private router: Router) {}

  ngOnInit(): void {}

  onScrollToRequestDemo(mouseEvent: MouseEvent): void {
    mouseEvent.preventDefault();
    this.href = this.router.url.concat('#request-a-demo');
    this.homeService.onScrollToRequestDemo();
  }
}
